export default interface CharterUpNavigationDTO {
  navigationItems: NavigationItemKey[]
}

export enum NavigationItemKey {
  Quotes = 'quotes',
  Reservations = 'reservations',
  Support = 'support',
  QuoteBuilder = 'quote-builder',
  EnterpriseTracking = 'enterprise-tracking',
  Profile = 'profile',
  Organization = 'organization',
  Finance = 'finance',
}
